<template>
  <form class="categories-table--row">
    <div
      class="name"
      @click="handleEdit"
    >
      <span :style="{'color' : category.color}">{{ category.name }}</span>
      <img
        class="edit-icon"
        alt="icon-edit"
        :src="require('@/assets/img/icons/icon-edit.svg')"
      />

    </div>
    <div @click="handleRemove">
      <img
        class="remove-icon"
        alt="icon-edit"
        :src="require('@/assets/img/icons/close-menu.svg')"
      />
    </div>
    <div class="d-flex justify-content-end align-items-center">
      <button
        type="button"
        class="accordion-button"
        :class="{ shown: isShown }"
        @click="handleToggle()"
      >
        <img
          :src="require('@/assets/img/icons/icon-arrow-down.svg')"
          alt="close"
        />
      </button>
    </div>
  </form>
</template>

<script>

export default {
  props: {
    category: {
      type: Object,
      required: true
    },
    isShown: {
      type: Boolean,
      required: true
    },
    editing: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isSuperAdmin () {
      return this.$store.getters['LoginStore/isSuperAdmin']
    }
  },
  data () {
    return {
      taxCode: null,
      accountNumber: null
    }
  },
  methods: {

    handleToggle () {
      this.$emit('toggle')
    },
    handleClose () {
      this.$emit('close')
    },
    handleEdit () {
      if (
        this.category?.id
      ) {
        this.$emit('editCategory', this.category)
      }
    },
    handleRemove () {
      this.$emit('removeCategory', this.category.id)
    }
  }
}
</script>

<style lang="scss" scoped>
.remove-icon,
.edit-icon {
  opacity: 0;
  transition: 150ms all ease-out;
}

.edit-icon {
  margin-left: 5px;
}
.remove-icon {
  width: 8px;
  height: 8px;
  margin-left: 5px;
}
.categories-table--row {
  display: grid;
  grid-column-gap: 8px;
  grid-template-columns: 1fr 15px 15px;
  height: 24px;
  align-items: center;
  margin-bottom: 4px;
  cursor: pointer;
  &:hover {
    .remove-icon {
      opacity: 1;
      width: 8px;
      height: 8px;
      margin-left: 5px;
    }
  }
}

.name {
  display: flex;

  span {
    font-weight: 500;
    font-size: 15px;
    &:hover {
      + .edit-icon {
        opacity: 1;
        margin-left: 5px;
      }
    }
  }
}

.accordion-button {
  border: none;
  background: transparent;
  appearance: none;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0px !important;
  transition: transform 0.2s ease-in-out;
  img {
    width: 8px;
    height: 4px;
  }
  &.shown {
    transform: rotate(180deg);
    transition: transform 0.2s ease-in-out;
  }
}
</style>
